
<div class="row">
  <div class="col-sm-12">
    <h3 class="sub-title alert alert-info">Curricula</h3>
  </div>

</div>
<div class="table-responsive" *ngIf="curricular.length>0">
<span [appMath]="''"></span>
<table  datatable [dtOptions]="dtOptions" class="table table-striped display compact">
  <thead>
  <tr>
  <th>Id</th>

  <th>name</th>
  <th>Levels</th>
  </tr>
  </thead>

  <tbody>

  <tr *ngFor="let curriculum of curricular;">
    <td>{{curriculum['id']}}</td>
    <td>{{curriculum['name']}}</td>
     <td>

      <a [routerLink]="['/admin/curriculum/show',curriculum.server_curriculum_id]">
         {{curriculum['levelCount']}}
      </a>
      </td>



  </tr>

  </tbody>

</table>

</div>

<app-spinner *ngIf="(curricular.length==0) && loading"></app-spinner>
<div *ngIf="(curricular.length==0) && !loading" class="text-center">No Records Found </div>



